import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { PATH } from 'src/features/navigation/utils/constants';
import DeleteZoneFormModal from 'src/features/zone/components/form/DeleteZoneFormModal';
import UpdateZoneFormModal from 'src/features/zone/components/form/UpdateZoneFormModal';
import { zoneMessages } from 'src/features/zone/utils/messages';
import { Zone } from 'src/features/zone/utils/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellZoneActions({ row }: CellContext<Zone, unknown>) {
    const { formatMessage } = useIntl();
    const manageZones = useHasPermissions([PERMISSION.MANAGE_ZONES]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                {manageZones && (
                    <>
                        <Tooltip>
                            <UpdateZoneFormModal
                                selectedZone={row.original}
                                semantics={{ entryName: formatMessage(zoneMessages.zone).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateZoneFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteZoneFormModal
                                selectedZone={row.original}
                                semantics={{ entryName: formatMessage(zoneMessages.zone).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteZoneFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.ADMINISTRATION}/zone/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage
                            defaultMessage={generalMessages.dashboard.defaultMessage}
                            id={generalMessages.dashboard.id}
                        />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
